import config from "./config";

let ip = 'localhost'

export default {
    ...config,
    debug: true,
    soon: false,
    ssl: false,
    directives: {
        connectSrc: [
            ip + ":50011", ip + ":50010", ip + ":50012"
        ],
        imgSrc: [
            "blob:", ip + ":50012", ip + ":50010"
        ],
        fontSrc: [
            "data:"
        ]
    },
    urls: {
        api: ip + ':50011',
        cdn: ip + ':50012'
    },
    serverIp: ['127.0.0.1', '::1', ip],
    siteOrigin: ['http://' + ip + ':50010']
}
